import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Products } from "@/components/Products";
import { Value } from "@/components/Value";
import { MultiLocal } from "@/components/MultiLocal";
import { HowItWorks } from "@/components/HowItWorks";
import { Ecosystem } from "@/components/Ecosystem";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id === "#") {
        e.preventDefault();
        return;
      }
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -84 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F8F3] font-sans text-[#1F3D35] antialiased" data-testid="tupu-landing">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Value />
        <MultiLocal />
        <HowItWorks />
        <Ecosystem />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
